'use client'

import { BlankFillingQuestion } from '@entities/lesson'
import { LessonReviewAnswerStatus, lessonReviewAnswerStatusSchema } from '@features/lesson-review'
import { useTranslation } from '@shared/config/i18n'
import { clsx } from 'clsx'
import React from 'react'
import { match } from 'ts-pattern'

import { HStack, Input, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: BlankFillingQuestion
  value: Undefinable<string>
  handleChangeCurrentFunnelValue: (value: string) => void
  canNavigateNextFunnel: boolean
  status: LessonReviewAnswerStatus
  handleChangeCurrentStatus: (status: LessonReviewAnswerStatus) => void
}

export const BlankFillingQuizFunnel = ({
  question,
  value,
  handleChangeCurrentFunnelValue,
  canNavigateNextFunnel,
  status,
  handleChangeCurrentStatus,
}: Props) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <VStack className="py-5 gap-2">
        <HStack className="gap-1 flex-wrap">
          {question.source.body.map((text) => {
            const isAnswer = question.source.answer.map((answer) => answer.toLowerCase()).includes(text.toLowerCase())
            const isCorrect = isAnswer && canNavigateNextFunnel

            return (
              <Typography
                size="h1"
                className={clsx(
                  'font-medium transition-all duration-300 ease-in-out break-words',
                  isAnswer ? 'text-white  px-2 border-b-[1.5px] border-gray-900' : 'text-gray-900',
                  isCorrect && 'text-[#819DFF] animate-fade',
                )}
                style={{
                  opacity: isCorrect ? 1 : isAnswer ? 0.5 : 1,
                }}
                key={text}
              >
                {text}
              </Typography>
            )
          })}
        </HStack>
        <Typography size="h6" className="font-normal text-gray-500">
          {question.source.ai_translation}
        </Typography>
      </VStack>

      <VStack className="gap-2">
        <Typography className="text-gray-400" size="h6">
          {t('lesson.quiz.answerInput')}
        </Typography>
        <Input
          className="w-full"
          onChange={(event) => handleChangeCurrentFunnelValue(event.target.value)}
          value={value ?? ''}
          disabled={canNavigateNextFunnel}
          name="answer"
          variant={match(status)
            .with(lessonReviewAnswerStatusSchema.Enum.INCORRECT, () => 'error' as const)
            .otherwise(() => 'default' as const)}
          onFocus={() => {
            handleChangeCurrentStatus(lessonReviewAnswerStatusSchema.Enum.NOT_ANSWERED)
          }}
        />
      </VStack>
    </React.Fragment>
  )
}
